import React from 'react'
import * as styles from './ContentEmbeddedTwoUpGrid.module.scss'
import TitleLockup, {
  TitleLockupProps
} from 'src/modules/molecules/title-lockup'
import cn from 'classnames'

type GridItemProps = {
  title: string
  mediaSrc: string
  altText?: string
  content: string
}

type ContentEmbeddedTwoUpGridProps = {
  id?: string
  bgColor?: 'white' | 'gray' | 'black'
  titleProps?: TitleLockupProps
  description?: string
  gridItems: GridItemProps[]
  paddingBottom?: boolean // Updated to boolean
}

const getBackgroundColor = (bgColor?: string) => {
  switch (bgColor) {
    case 'gray':
      return 'var(--color-gray-50)'
    case 'dark':
      return 'var(--color-dark)'
    case 'light':
    default:
      return 'var(--color-light)'
  }
}

const ContentEmbeddedTwoUpGrid: React.FC<ContentEmbeddedTwoUpGridProps> = ({
  id,
  bgColor = 'white',
  titleProps,
  description,
  gridItems,
  paddingBottom = true
}) => {
  const getGridItemBackground = () => {
    switch (bgColor) {
      case 'gray':
        return 'var(--color-light)'
      case 'white':
      default:
        return 'var(--color-gray-50)'
    }
  }

  return (
    <section
      id={id}
      className={styles.container}
      style={{
        backgroundColor: getBackgroundColor(bgColor),
        paddingBottom: paddingBottom ? undefined : '0'
      }}
    >
      <div className={styles.wrapper}>
        {(titleProps || description) && (
          <div className={styles.title}>
            {titleProps && <TitleLockup {...titleProps} />}
            {description && <p>{description}</p>}
          </div>
        )}
        <div className={styles.grid}>
          {gridItems.map((item, index) => (
            <div
              key={index}
              className={cn(styles.gridItem)}
              style={{
                backgroundColor: getGridItemBackground()
              }}
            >
              <TitleLockup
                visualStyle='h4'
                headingLevel='h4'
                title={item.title}
              />
              <div className={styles.img}>
                <img src={item.mediaSrc} alt={item.altText || ''} />
              </div>
              <p>{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ContentEmbeddedTwoUpGrid
